import MuiBreadcrumbs from "@mui/material/Breadcrumbs";
const Breadcrumbs = MuiBreadcrumbs;
export default Breadcrumbs;
